






















import { IClient } from "@/models/clients";
import { IClientProviderMethods } from "@/models/providers/client";
import { Component, Inject, Vue } from "vue-property-decorator";

import ClientLogin from "@/components/app/global/client/settings/clientDetails/clientLogin.vue";

@Component({
  components: {
    "client-login": ClientLogin,
    "client-2fa-contextualise": () =>
      import("@/components/app/admin/clients/client2faContextualise.vue")
  }
})
export default class AdminClientSecuritySettingsView extends Vue {
  public $refs!: {
    clientLogin: ClientLogin;
  };

  // Inject

  @Inject({ from: "clientMethods" })
  public readonly $clientMethods!: IClientProviderMethods;

  // Data

  public isFormChanged = false;
  public isProcessing = false;
  public hasErrors = false;

  // Life-cycle methods

  public created() {
    this.$clientMethods.reloadData();
  }

  // Computed

  public get clientId(): IClient["id"] {
    return this.$route.params.clientId;
  }
}
